const ReactTips = () => {
  return <div>react-tips</div>;
};

export default ReactTips;
